/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCarePrincipalSettingsDTO
 */
export interface UpdateCarePrincipalSettingsDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    puServiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    userManualUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    exportDebitFormat?: UpdateCarePrincipalSettingsDTOExportDebitFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    contractTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    contractLogo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    optInRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    preliminaryStatusActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    exportCardsAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    puPresentation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarePrincipalSettingsDTO
     */
    orderCardEnabled?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum UpdateCarePrincipalSettingsDTOExportDebitFormatEnum {
    Letter = 'LETTER',
    System = 'SYSTEM'
}

export function UpdateCarePrincipalSettingsDTOFromJSON(json: any): UpdateCarePrincipalSettingsDTO {
    return UpdateCarePrincipalSettingsDTOFromJSONTyped(json, false);
}

export function UpdateCarePrincipalSettingsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCarePrincipalSettingsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'puServiceId': !exists(json, 'puServiceId') ? undefined : json['puServiceId'],
        'userManualUrl': !exists(json, 'userManualUrl') ? undefined : json['userManualUrl'],
        'exportDebitFormat': !exists(json, 'exportDebitFormat') ? undefined : json['exportDebitFormat'],
        'contractTemplate': !exists(json, 'contractTemplate') ? undefined : json['contractTemplate'],
        'contractLogo': !exists(json, 'contractLogo') ? undefined : json['contractLogo'],
        'optInRequired': !exists(json, 'optInRequired') ? undefined : json['optInRequired'],
        'preliminaryStatusActive': !exists(json, 'preliminaryStatusActive') ? undefined : json['preliminaryStatusActive'],
        'exportCardsAutomatically': !exists(json, 'exportCardsAutomatically') ? undefined : json['exportCardsAutomatically'],
        'puPresentation': !exists(json, 'puPresentation') ? undefined : json['puPresentation'],
        'orderCardEnabled': !exists(json, 'orderCardEnabled') ? undefined : json['orderCardEnabled'],
    };
}

export function UpdateCarePrincipalSettingsDTOToJSON(value?: UpdateCarePrincipalSettingsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carePrincipalId': value.carePrincipalId,
        'puServiceId': value.puServiceId,
        'userManualUrl': value.userManualUrl,
        'exportDebitFormat': value.exportDebitFormat,
        'contractTemplate': value.contractTemplate,
        'contractLogo': value.contractLogo,
        'optInRequired': value.optInRequired,
        'preliminaryStatusActive': value.preliminaryStatusActive,
        'exportCardsAutomatically': value.exportCardsAutomatically,
        'puPresentation': value.puPresentation,
        'orderCardEnabled': value.orderCardEnabled,
    };
}

